import { usePaymentsQuery } from '@/features/payments/hooks/usePaymentsQuery';
import { usePaymentQuery } from '@/features/payments/hooks/usePaymentQuery';
import { refundFlagsOf, type RefundFlags } from '@/features/payments/lib/refundFlags';
import type { AdminPaymentDetail } from '@/lib/api-admin/types';

export interface OrderPaymentRefundFlags {
  /** 이 주문의 첫 결제(없으면 undefined). */
  paymentId: string | undefined;
  /** 결제 상세를 읽은 뒤에만 채워진다 — 읽기 전·실패면 null. */
  flags: RefundFlags | null;
  /** 결제 상세(수기 환불 기록 팝업에 넘긴다) — 읽기 전·실패면 null. */
  payment: AdminPaymentDetail | null;
}

/**
 * QA-432 후속 — 주문의 결제 환불 플래그. 토스 결제키가 없는 결제(고도몰 이관·수기주문·자체 무통장, manualRefundOnly)는
 * [PG 상태 동기화]로 맞출 것이 없어(BE changed=false) 주문 상세에서 버튼을 숨기고 결제 상세 [수기 환불 기록]으로 안내한다.
 * 결제 목록 keyword 는 orderId 부분일치라 같은 orderId 만 남긴다(ClaimRefundPaymentLinks 와 같은 방식).
 */
export const useOrderPaymentRefundFlags = (orderId: string | undefined, enabled: boolean): OrderPaymentRefundFlags => {
  const paymentsQuery = usePaymentsQuery({ keyword: orderId ?? '', size: 10 }, { enabled: enabled && Boolean(orderId) });
  const paymentId = (paymentsQuery.data?.items ?? []).find((p) => p.orderId === orderId)?.paymentId;
  const paymentQuery = usePaymentQuery(enabled ? paymentId : undefined);
  const payment = paymentQuery.data ?? null;
  return { paymentId, flags: payment ? refundFlagsOf(payment) : null, payment };
};
